<div class="flex" [ngClass]="{'sidebar-active': app.sidebarActive}">
    <div class="sidebar-next-right-block">
        <div class="partner-right-block-body">
            <div class="flex flex-row">
                <div class="partner-business-info-title">Business Info</div>
                <div style="margin-left: auto;"><button [disabled]="true" class="btn-darkblue" pButton label="Update" style="width: 91px; height: 45px;" (click)="handleShowBusinessInfoUpdate()"></button></div>
            </div>
            <div class="partner-business-info-title-min">Registered Information</div>
            <div class="flex flex-row">
                <div class="partner-business-info-input-field">
                    <div class="partner-business-info-input-label">Registered Company info</div>
                    <input [disabled]="true" [(ngModel)]="businessInfo.BusinessName" class="partner-business-info-input" type="text" pInputText />
                </div>
                <div class="partner-business-info-input-field">
                    <div class="partner-business-info-input-label">Trading Name</div>
                    <input [disabled]="true" [(ngModel)]="businessInfo.TradingName" class="partner-business-info-input" type="text" pInputText />
                </div>
            </div>
            <div class="partner-business-info-input-field">
                <div class="partner-business-info-input-label">Company Address</div>
                <input [disabled]="true" [(ngModel)]="businessInfo.BusinessAddress" class="partner-business-info-input" type="text" pInputText />
                <div class="flex flex-row">
                    <input [disabled]="true" [(ngModel)]="businessInfo.BusinessAddressCity" class="partner-business-info-input-field-min partner-business-info-input"
                           type="text" pInputText style="margin-top: 25px;" />
                    <input [disabled]="true" [(ngModel)]="businessInfo.BusinessAddressPostalCode" class="partner-business-info-input-field-min partner-business-info-input"
                           style="margin-left: auto; margin-top: 25px;" type="text" pInputText />
                </div>
                <div class="flex flex-row">
                    <div class="partner-business-info-input-field-min">
                        <div class="partner-business-info-input-label">Company Phone</div>
                        <input [(ngModel)]="businessInfo.BusinessPhone" [disabled]="true" class="partner-business-info-input" type="text" pInputText />
                    </div>
                    <div class="partner-business-info-input-field-min" style="margin-left: auto">
                        <div class="partner-business-info-input-label">Company Email</div>
                        <input [(ngModel)]="businessInfo.BusinessEmail" [disabled]="true" class="partner-business-info-input" type="text" pInputText />
                    </div>
                </div>
            </div>
        </div>
        <partner-business-info-update *ngIf="showBusinessInfoUpdateSidebar" [visible]="showBusinessInfoUpdateSidebar" [onHide]="handleBusinessInfoUpdateHide"></partner-business-info-update>
        <p-toast position="top-right"></p-toast>
    </div>
</div>